// Help Center JavaScript

// Modal functions
function openModal(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
}

function closeModal(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }
}

// Quick action openers
function openGiftCardChecker() {
  // Always use the in-page modal instance so it honors this page's app block settings.
  openModal('giftCardModal');
}

function openOrderTracker() {
  openModal('orderTrackerModal');
}

function openPasswordReset() {
  openModal('passwordResetModal');
}

function openEmailChange() {
  openModal('emailChangeModal');
}

function openOrderCancel() {
  openModal('orderCancelModal');
}

// Live Chat function - customize this based on your chat provider
function openLiveChat() {
  // Examples for common chat providers:
  
  // Zendesk Chat
  // if (typeof zE !== 'undefined') { zE('messenger', 'open'); }
  
  // Tidio
  // if (typeof tidioChatApi !== 'undefined') { tidioChatApi.open(); }
  
  // Intercom
  // if (typeof Intercom !== 'undefined') { Intercom('show'); }
  
  // Drift
  // if (typeof drift !== 'undefined') { drift.api.sidebar.open(); }
  
  // LiveChat
  // if (typeof LiveChatWidget !== 'undefined') { LiveChatWidget.call('maximize'); }
  
  // Gorgias
  // if (typeof GorgiasChat !== 'undefined') { GorgiasChat.open(); }
  
  // Fallback - alert or custom action
  console.log('Live chat opened');
  alert('Live chat will open here. Configure your chat provider in help-center-demo.js');
}

// Close modal when clicking outside
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('help-modal')) {
    closeModal(e.target.id);
  }
});

// Close modal with Escape key
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    const activeModal = document.querySelector('.help-modal.active');
    if (activeModal) {
      closeModal(activeModal.id);
    }
  }
});

// Form handlers
document.addEventListener('DOMContentLoaded', function() {
  
  // Gift Card Form
  // Note: Gift card balance checking is now handled by the Gift Card Balance Checker app
  // The app will render its interface in the #giftCardAppContainer div when the modal opens
  
  // Order Tracker Form
  const orderTrackerForm = document.getElementById('orderTrackerForm');
  if (orderTrackerForm) {
    orderTrackerForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const orderNumber = document.getElementById('trackOrderNumber').value.trim();
      const email = document.getElementById('trackOrderEmail').value.trim();
      const resultDiv = document.getElementById('orderTrackerResult');
      
      // Remove # if user included it
      const cleanOrderNumber = orderNumber.replace('#', '');
      
      // Validate inputs
      if (!cleanOrderNumber || !email) {
        resultDiv.style.display = 'block';
        resultDiv.className = 'result-display error';
        resultDiv.innerHTML = 'Please enter both your order number and email address.';
        return;
      }
      
      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        resultDiv.style.display = 'block';
        resultDiv.className = 'result-display error';
        resultDiv.innerHTML = 'Please enter a valid email address.';
        return;
      }
      
      // Show loading state
      resultDiv.style.display = 'block';
      resultDiv.className = 'result-display';
      resultDiv.innerHTML = 'Verifying your order...';
      
      // Submit to backend endpoint for order verification and magic link generation
      fetch('https://order-lookup-backend-36auxzi48-sitetune-gmailcoms-projects.vercel.app/apps/order-lookup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          order_number: cleanOrderNumber,
          email: email
        })
      })
      .then(function(response) {
        return response.json().then(function(data) {
          return { status: response.status, data: data };
        });
      })
      .then(function(result) {
        if (result.status === 200 && result.data.success) {
          // Successfully sent magic link
          resultDiv.className = 'result-display success';
          resultDiv.innerHTML = '<strong>✓ Email Sent!</strong><br><br>' +
            'We\'ve sent an order status link to <strong>' + email + '</strong><br><br>' +
            'Check your email and click the "View Your Order" button to see your order status and tracking information.<br><br>' +
            '<small>Don\'t see the email? Check your spam folder or try again in a few minutes.</small>';
        } else if (result.status === 404) {
          // Order not found or email doesn't match
          resultDiv.className = 'result-display error';
          resultDiv.innerHTML = '<strong>Order Not Found</strong><br><br>' +
            'We couldn\'t find order #' + cleanOrderNumber + ' with that email address.<br><br>' +
            'Please check:<br>' +
            '• Your order number is correct<br>' +
            '• The email matches the one used at checkout<br><br>' +
            'Need help? Call us at <a href="tel:(713) 526-5221" style="color: #c41e3a; font-weight: bold;">(713) 526-5221</a>';
        } else if (result.status === 429) {
          // Rate limited
          resultDiv.className = 'result-display error';
          resultDiv.innerHTML = '<strong>Too Many Requests</strong><br><br>' +
            'Please wait a few minutes before trying again.<br><br>' +
            'Or call us at <a href="tel:(713) 526-5221" style="color: #c41e3a; font-weight: bold;">(713) 526-5221</a>';
        } else {
          // Generic error
          resultDiv.className = 'result-display error';
          resultDiv.innerHTML = '<strong>Unable to Process Request</strong><br><br>' +
            result.data.message || 'Please try again or contact customer service.<br><br>' +
            'Call us at <a href="tel:(713) 526-5221" style="color: #c41e3a; font-weight: bold;">(713) 526-5221</a>';
        }
      })
      .catch(function(error) {
        // Network error or server unavailable
        resultDiv.className = 'result-display error';
        resultDiv.innerHTML = '<strong>Connection Error</strong><br><br>' +
          'We\'re having trouble connecting to our servers. Please try again in a moment.<br><br>' +
          'For immediate assistance, call <a href="tel:(713) 526-5221" style="color: #c41e3a; font-weight: bold;">(713) 526-5221</a><br>' +
          'Monday-Friday, 8:30am-5pm CST';
      });
    });
  }
  
  // Password Reset Form
  const passwordResetForm = document.getElementById('passwordResetForm');
  if (passwordResetForm) {
    passwordResetForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const email = document.getElementById('resetEmail').value;
      const resultDiv = document.getElementById('passwordResetResult');
      
      resultDiv.style.display = 'block';
      resultDiv.className = 'result-display';
      resultDiv.innerHTML = 'Sending reset link...';
      
      // Use Shopify's password reset endpoint
      fetch('/account/recover', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: 'form_type=recover_customer_password&email=' + encodeURIComponent(email)
      })
      .then(function() {
        resultDiv.className = 'result-display success';
        resultDiv.innerHTML = '<strong>Success!</strong> If an account exists for ' + email + ', you will receive a password reset email shortly.';
      })
      .catch(function() {
        resultDiv.className = 'result-display error';
        resultDiv.innerHTML = 'There was an error. Please try again or contact customer service.';
      });
    });
  }
  
  // Email Change Form
  const emailChangeForm = document.getElementById('emailChangeForm');
  if (emailChangeForm) {
    emailChangeForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const resultDiv = document.getElementById('emailChangeResult');
      
      resultDiv.style.display = 'block';
      resultDiv.className = 'result-display success';
      resultDiv.innerHTML = 'To change your email address, please contact customer service at (713) 526-5221 or email us directly.';
    });
  }
  
  // Order Cancel Form
  const orderCancelForm = document.getElementById('orderCancelForm');
  if (orderCancelForm) {
    orderCancelForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const orderNumber = document.getElementById('cancelOrderNumber').value;
      const reason = document.getElementById('cancelReason').value;
      const details = document.getElementById('cancelDetails').value;
      const resultDiv = document.getElementById('orderCancelResult');
      
      resultDiv.style.display = 'block';
      resultDiv.className = 'result-display';
      resultDiv.innerHTML = 'Submitting your request...';
      
      // TODO: Replace with actual form submission to your email/ticketing system
      setTimeout(function() {
        resultDiv.className = 'result-display success';
        resultDiv.innerHTML = '<strong>Request Submitted!</strong><br>Order #' + orderNumber + '<br>We will contact you shortly. For immediate assistance, please call (713) 526-5221.';
      }, 1500);
    });
  }
  
  // Update chat status based on business hours
  updateChatStatus();
});

// Check if within business hours for live chat status
function updateChatStatus() {
  const chatStatus = document.querySelector('.chat-status');
  if (!chatStatus) return;
  
  const now = new Date();
  const day = now.getDay(); // 0 = Sunday, 6 = Saturday
  const hour = now.getHours();
  const minutes = now.getMinutes();
  const currentTime = hour + (minutes / 60);
  
  // Business hours: Monday-Friday, 8:30am-5pm CST
  // Note: This is a simplified check - adjust for timezone as needed
  const isWeekday = day >= 1 && day <= 5;
  const isBusinessHours = currentTime >= 8.5 && currentTime < 17;
  
  if (isWeekday && isBusinessHours) {
    chatStatus.className = 'chat-status chat-status--online';
    chatStatus.textContent = 'Online';
  } else {
    chatStatus.className = 'chat-status chat-status--offline';
    chatStatus.textContent = 'Offline';
  }
}

// Update status every minute
setInterval(updateChatStatus, 60000);
